import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngryBirdGameSelectorComponent } from './angry-bird-game-selector/angry-bird-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AngryBirdGameCoreService } from './angry-bird-game-core.service';

@NgModule({
  declarations: [AngryBirdGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [AngryBirdGameCoreService],
  exports: [AngryBirdGameSelectorComponent],
})
export class AngryBirdGameCoreModule {}
